import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Button from 'src/components/form/Button';
import { AddRiskScenarioModal } from 'src/components/modals';
import { MPEvents } from 'src/utils/mixpanel/types';
import { mpEvent } from 'src/utils/mixpanel/useMixPanel';

interface AddRiskScenarioProps {
  assessmentId: string;
  assessmentName: string;
  existingScenarioIds: string[];
}

type ScenarioTab = 'from_new' | 'from_lib' | 'from_csv' | 'from_ai';

export const AddRiskScenario: React.FC<AddRiskScenarioProps> = ({
  assessmentId,
  assessmentName,
  existingScenarioIds,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialTab, setInitialTab] = useState<ScenarioTab>('from_new');
  const [searchParams, setSearchParams] = useSearchParams();

  const open = (tab: ScenarioTab) => {
    setInitialTab(tab);
    setIsOpen(true);
  };

  // Deep link: `?addScenario=ai` (e.g. the "return to the other assessment" link from the AI wizard's
  // cross-assessment notice) opens the modal straight on "Create with AI". Keyed on searchParams (not
  // just mount) so it also fires when navigating between two assessment pages without a remount; the
  // param is consumed immediately so a refresh/close doesn't reopen it.
  useEffect(() => {
    if (searchParams.get('addScenario') !== 'ai') return;
    open('from_ai');
    const next = new URLSearchParams(searchParams);
    next.delete('addScenario');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <>
      {isOpen && (
        <AddRiskScenarioModal
          onClose={() => setIsOpen(false)}
          assessmentId={assessmentId}
          assessmentName={assessmentName}
          existingScenarioIds={existingScenarioIds}
          invalidateQueries={['assessment', 'assessmentRiskRegister']}
          initialTab={initialTab}
        />
      )}
      <Button
        onClick={() => {
          open('from_new');
          mpEvent(MPEvents.ButtonClick, {
            button: 'Add Risk Scenario',
            tags: ['SCENARIO'],
          });
        }}
        primary
        data-cy="add-scenario-button"
      >
        + ADD RISK SCENARIO
      </Button>
    </>
  );
};
